import React, { useEffect } from 'react';
import { theme } from '../theme/theme';

const Toast = ({ message, type = 'success', onClose, duration = 3000 }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const getToastStyles = () => {
    const baseStyles = {
      position: 'fixed',
      bottom: theme.spacing.lg,
      right: theme.spacing.lg,
      padding: `${theme.spacing.md} ${theme.spacing.lg}`,
      color: theme.colors[type].contrast,
      borderRadius: theme.borderRadius.md,
      boxShadow: theme.shadows.lg,
      zIndex: 1000,
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing.md,
      minWidth: '300px',
      maxWidth: '400px',
      animation: 'slideIn 0.3s ease-out',
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.body2.fontSize,
      lineHeight: theme.typography.body2.lineHeight,
      backdropFilter: 'blur(8px)',
      border: `1px solid ${theme.colors[type].light}`,
      background: `${theme.colors[type].main}dd`
    };

    return baseStyles;
  };

  const getIcon = () => {
    switch (type) {
      case 'success':
        return '✓';
      case 'error':
        return '✕';
      case 'warning':
        return '⚠';
      default:
        return '✓';
    }
  };

  return (
    <div style={getToastStyles()}>
      <div style={{ 
        fontSize: '20px',
        lineHeight: 1,
        opacity: 0.9
      }}>
        {getIcon()}
      </div>
      <div style={{ flex: 1 }}>{message}</div>
      <button
        onClick={onClose}
        style={{
          background: 'none',
          border: 'none',
          color: 'inherit',
          cursor: 'pointer',
          padding: theme.spacing.xs,
          fontSize: '20px',
          lineHeight: 1,
          opacity: 0.7,
          transition: `opacity ${theme.transitions.fast}`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '24px',
          height: '24px',
          borderRadius: '50%',
          '&:hover': {
            background: 'rgba(255, 255, 255, 0.1)'
          }
        }}
        onMouseOver={(e) => e.target.style.opacity = '1'}
        onMouseOut={(e) => e.target.style.opacity = '0.7'}
      >
        ×
      </button>
      <style>
        {`
          @keyframes slideIn {
            from {
              transform: translateX(100%);
              opacity: 0;
            }
            to {
              transform: translateX(0);
              opacity: 1;
            }
          }
        `}
      </style>
    </div>
  );
};

export default Toast; 